/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LockedSlotPhysician
 */
export interface LockedSlotPhysician {
    /**
     * 
     * @type {string}
     * @memberof LockedSlotPhysician
     */
    physician_id: string;
    /**
     * A plan (Stripe price id) that unlocks this practitioner for the patient.
     * @type {string}
     * @memberof LockedSlotPhysician
     */
    plan_id: string;
    /**
     * 
     * @type {string}
     * @memberof LockedSlotPhysician
     */
    plan_name: string;
}

/**
 * Check if a given object implements the LockedSlotPhysician interface.
 */
export function instanceOfLockedSlotPhysician(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "physician_id" in value;
    isInstance = isInstance && "plan_id" in value;
    isInstance = isInstance && "plan_name" in value;

    return isInstance;
}

export function LockedSlotPhysicianFromJSON(json: any): LockedSlotPhysician {
    return LockedSlotPhysicianFromJSONTyped(json, false);
}

export function LockedSlotPhysicianFromJSONTyped(json: any, ignoreDiscriminator: boolean): LockedSlotPhysician {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'physician_id': json['physician_id'],
        'plan_id': json['plan_id'],
        'plan_name': json['plan_name'],
    };
}

export function LockedSlotPhysicianToJSON(value?: LockedSlotPhysician | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'physician_id': value.physician_id,
        'plan_id': value.plan_id,
        'plan_name': value.plan_name,
    };
}

